<template>
  <transition name="slide-fade">
    <div class="col-12 col-lg-6 align-content-center">
      <div
        v-if="!isProcessed"
        class="media shadow rounded bg-white d-flex flex-row justify-content-center px-4 py-4 mx-2 my-4"
      >
        <div class="col-12 align-self-start d-flex justify-content-between top-bar">
          <div class="flex-start align-self-start">
            <h5 class="font-weight-bold" style="margin-bottom:0.1rem">{{ name }}</h5>

            <p>This media is currently processing. please check back later.</p>
          </div>
        </div>
      </div>

      <div
        v-else
        class="media shadow rounded bg-white d-flex flex-column justify-content-center my-4"
      >
        <div class="w-100">
          <div class="px-4 pt-0 pb-4 mx-2">
            <div class="d-flex justify-content-between">
              <router-link :to="{ name: 'media-view', params: { uuidId: uuidId } }">
                <div class="d-flex align-items-center">
                  <div class="title d-flex align-items-center">
                    <h4 class="font-weight-bold" style="margin-bottom:0.1rem">{{ name }}</h4>
                  </div>
                </div>
              </router-link>
              <div class="d-flex align-items-center">
                <a class @click.prevent="downloadMedia">
                  <button class="btn btn-primary w-100">
                    <i class="material-icons">save_alt</i>
                  </button>
                </a>
              </div>
            </div>

            <div class="d-flex w-100 flex-row justify-content-between my-1 flex-wrap">
              <div class="d-flex flex-column media-stats mb-2">
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">perm_media</i>
                  <em>Media Type:</em>
                  <span class="element-label">
                    <em v-if="isVideo">Video</em>
                    <em v-else>Image</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">save</i>
                  <em>Filesize:</em>
                  <span class="element-label">
                    <em>{{ humanFileSize }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">save_alt</i>
                  <em>Downloads:</em>
                  <span class="element-label">
                    <em>{{ numDownloads }}</em>
                  </span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="material-icons text-secondary">person</i>
                  <em>Contributed By:</em>
                  <router-link
                    :to="{ name: 'view-user', params: { id: contributedBy.uuid } }"
                  >{{ contributedBy.first_name }} {{ contributedBy.last_name }}</router-link>
                </div>
              </div>
            </div>
            <div
              @click="openImagePreview"
              v-bind:id="id"
              class="preview-container d-flex align-items-center"
              style
              v-bind:style="{ backgroundImage: 'url(' + signedThumbUrl + ')' }"
            >
              <div class="media-type-overlay d-flex align-items-center">
                <div v-if=" isVideo" class>
                  <i class="material-icons privacy">videocam</i>
                </div>
                <div v-else class>
                  <i class="material-icons privacy">image</i>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-3 media-stats">
              <i class="material-icons text-secondary">label</i>
              <em>Tags:</em>
            </div>
            <ul class="media-tags d-flex flex-wrap w-100 align-items-center justify-content-left">
              <li
                v-bind:key="tag.id"
                v-for="tag in tags"
                v-bind:class="{ selected: tag.isCurrentlySelected }"
              >{{ tag.title }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Media from "./Media";
import mediaService from "../services/media.service";
import { booleanLiteralTypeAnnotation } from "@babel/types";

export default {
  name: "MyMedia",
  extends: Media,
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    humanFileSize() {
      var i = Math.floor(Math.log(this.fileSize) / Math.log(1024));
      return (
        (this.fileSize / Math.pow(1024, i)).toFixed(2) * 1 +
        " " +
        ["B", "kB", "MB", "GB", "TB"][i]
      );
    }
  },
  data: function() {
    return {
      id: null
    };
  },
  props: {
    uuidId: String,
    name: String,
    description: String,
    userId: Number,
    fileSize: String,
    contributedBy: String,
    contributedAt: String,
    numDownloads: Number,
    isVideo: Boolean,
    objectUrl: String,
    durationInSeconds: Number,
    tags: Array,
    currentlySelectedTags: Array,
    userUuId: String,
    signedFullUrl: String,
    signedThumbUrl: String,
    currentPrivacyLevel: Number,
    isProcessed: Boolean,
    currentlyIsPublishable: Boolean
  },

  methods: {
    showImagePreview() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        title: "Title",
        text: "<img src='" + myImage.src + "'/>",
        html: true
      });

      swalWithBootstrapButtons.fire({
        title: "Delete " + this.name + "?",
        html:
          "Deleting a scenario will remove it from Community, including groups. Users who have already downloaded the scenario to their device will still have access to it.<br> <br> If you still want access to your scenario in Community you can always change its visibility to private.",
        type: "warning",
        showCancelButton: true,

        confirmButtonText: "Delete"
      });
    },
    downloadMedia() {
      mediaService.downloadMedia(this.uuidId).then(data => {
        if (this.isOnNative) {
          let url = data.url;
          window.webkit.messageHandlers.mediaImport.postMessage({
            url: data.url,
            fileName: data.fileName
          });
        } else {
          window.location = data.url;
        }
      });
    },
    changePrivacyLevel(newLevel) {
      let data = new FormData();
      data.append("newLevel", newLevel);
      mediaService.changePrivacyLevel(data, this.uuidId).then(response => {
        this.currentPrivacyLevel = Number(response.newLevel);
      });
    },
    lazyLoadPreview: function() {
      function getBgUrl(el) {
        var background = "";
        if (el.currentStyle) {
          background = el.currentStyle.backgroundImage;
        } else if (
          document.defaultView &&
          document.defaultView.getComputedStyle
        ) {
          background = document.defaultView.getComputedStyle(el, "")
            .backgroundImage;
        } else {
          background = el.style.backgroundImage;
        }
        return background.replace(/url\(['"]?(.*?)['"]?\)/i, "$1");
      }
      var previewContainer = document.getElementById(this.id);
      var image = document.createElement("img");
      image.src = getBgUrl(document.getElementById(this.id));
      image.onload = function() {
        previewContainer.className += " fade-in";
      };
    },
    openImagePreview() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          confirmButtonText: "Close"
        },
        buttonsStyling: false,
        heightAuto: true,
        html:
          '<div class="full-screen-preview preview-container d-flex align-items-center" style="width:80vh; height:60vh; background-image: url(' +
          this.signedFullUrl +
          ')"></div>'
      });
      swalWithBootstrapButtons.fire({});
    }
  },
  beforeMount() {
    this.id = "preview-pange-" + this._uid;
  },
  mounted() {
    this.lazyLoadPreview();
  }
};
</script>
<style scoped>
.media {
  min-height: 650px;
}

i.privacy {
  font-size: 50px;
  color: #6c757d;
  margin-left: -8px;
}

.title {
  min-height: 70px;
}

.media-stats em {
  color: #6c757d;
  margin-right: 10px;
  font-size: 14px;
}

.preview-container {
  position: relative;
  min-height: 260px;
  max-width: 100%;
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  opacity: 0;
}

.fade-in {
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
  -moz-transition: opacity 0.25s ease-in-out;
  -webkit-transition: opacity 0.25s ease-in-out;
}

.media-type-overlay {
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  opacity: 0.5;
}

.media-type-overlay i {
  color: #fff;
  font-size: 80px;
}
.media-stats i {
  margin-right: 5px;
}

.media-tags {
  padding: 10px;
  min-height: 80px;
  max-height: 80px;
  overflow-y: scroll;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid;
  border-color: #f8f9fa;
}

.media-tags li {
  margin: 2px;
  display: inline-block;
  color: #fff;
  background-color: #6c757d;

  border-radius: 7px;
  padding: 4px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.unpublished-alert {
  background-color: #CB2E37;

  text-align: center;
  border: none;
  border-radius: 0px;
}

.unpublished-alert em {
  color: #ffffff;
}

.noColor {
  filter: grayscale();
  opacity: 0.7;
}

@media (max-width: 575.98px) {
  .top-bar {
    flex-direction: column;
  }
}

.preview-container {
  cursor: pointer;
}
</style>
<style>
.full-screen-preview.preview-container {
  position: relative;
  max-width: 100%;
  width: 100%;
  height: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  opacity: 1;
}
</style>